import React, { useId } from 'react'

const svg = (
    <svg
        width="512"
        height="512"
        viewBox="0 0 512 512"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clip-path="url(#clip0_426_2)">
            <rect width="512" height="512" fill="white" />
            <rect width="512" height="512" fill="#8D7FE3" />
            <path
                d="M255.932 86.4619C264.865 86.4619 272.107 93.7044 272.107 102.638V141.61C272.107 144.342 275.033 146.075 277.429 144.763L318.705 122.152C326.54 117.86 336.37 120.733 340.662 128.568C344.954 136.404 342.082 146.235 334.247 150.527L278.005 181.336C274.368 183.328 272.107 187.145 272.107 191.292V332.233C272.107 336.612 276.857 339.342 280.64 337.137L297.345 327.401C300.834 325.368 302.98 321.633 302.98 317.594V250.727C302.98 229.595 314.223 210.059 332.494 199.442L376.761 176.558C384.486 172.069 394.386 174.693 398.874 182.418C403.362 190.142 400.739 200.043 393.014 204.531L348.747 227.416C340.442 232.242 335.332 241.122 335.332 250.727V299.007C335.332 301.781 338.34 303.51 340.736 302.113L378.091 280.343C385.81 275.845 395.713 278.456 400.211 286.175C404.71 293.894 402.099 303.798 394.38 308.296L279.034 378.195C274.734 380.801 272.107 385.464 272.107 390.493V409.944C272.107 418.878 264.865 426.12 255.932 426.12C246.998 426.12 239.756 418.878 239.756 409.944V390.523C239.756 385.487 237.121 380.818 232.81 378.215L117.055 308.308C109.33 303.821 106.704 293.921 111.19 286.196C115.677 278.47 125.577 275.844 133.302 280.331L170.914 302.175C173.31 303.567 176.314 301.838 176.314 299.067V250.771C176.314 241.151 171.188 232.26 162.863 227.439L118.421 204.544C110.69 200.067 108.051 190.171 112.528 182.439C117.004 174.707 126.9 172.069 134.631 176.545L179.073 199.441C197.388 210.046 208.665 229.607 208.665 250.771V317.567C208.665 321.612 210.817 325.351 214.315 327.382L231.231 337.207C235.014 339.404 239.756 336.674 239.756 332.299V191.241C239.756 187.106 237.507 183.297 233.885 181.301L178.028 150.506C170.204 146.193 167.358 136.354 171.671 128.53C175.984 120.706 185.823 117.86 193.646 122.173L234.426 144.655C236.822 145.976 239.756 144.243 239.756 141.507V102.638C239.756 93.7044 246.998 86.4619 255.932 86.4619Z"
                fill="url(#paint0_linear_426_2)"
            />
        </g>
        <defs>
            <linearGradient
                id="paint0_linear_426_2"
                x1="256.146"
                y1="33.4077"
                x2="244.29"
                y2="485.927"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="white" />
                <stop offset="1" stopColor="#E4DCFF" />
            </linearGradient>
            <clipPath id="clip0_426_2">
                <rect width="512" height="512" fill="white" />
            </clipPath>
        </defs>
    </svg>
)

const TreechatIcon = ({ size = 512, className = 'treechat-icon' } = {}) => {
    const instanceId = useId().replace(/:/g, '')
    const gradientId = `treechat-gradient-${instanceId}`
    const clipId = `treechat-clip-${instanceId}`

    return (
        <svg
            className={className}
            width={size}
            height={size}
            viewBox="0 0 512 512"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath={`url(#${clipId})`}>
                <rect width="512" height="512" fill="white" />
                <rect width="512" height="512" fill="#8D7FE3" />
                <path
                    d="M255.932 86.4619C264.865 86.4619 272.107 93.7044 272.107 102.638V141.61C272.107 144.342 275.033 146.075 277.429 144.763L318.705 122.152C326.54 117.86 336.37 120.733 340.662 128.568C344.954 136.404 342.082 146.235 334.247 150.527L278.005 181.336C274.368 183.328 272.107 187.145 272.107 191.292V332.233C272.107 336.612 276.857 339.342 280.64 337.137L297.345 327.401C300.834 325.368 302.98 321.633 302.98 317.594V250.727C302.98 229.595 314.223 210.059 332.494 199.442L376.761 176.558C384.486 172.069 394.386 174.693 398.874 182.418C403.362 190.142 400.739 200.043 393.014 204.531L348.747 227.416C340.442 232.242 335.332 241.122 335.332 250.727V299.007C335.332 301.781 338.34 303.51 340.736 302.113L378.091 280.343C385.81 275.845 395.713 278.456 400.211 286.175C404.71 293.894 402.099 303.798 394.38 308.296L279.034 378.195C274.734 380.801 272.107 385.464 272.107 390.493V409.944C272.107 418.878 264.865 426.12 255.932 426.12C246.998 426.12 239.756 418.878 239.756 409.944V390.523C239.756 385.487 237.121 380.818 232.81 378.215L117.055 308.308C109.33 303.821 106.704 293.921 111.19 286.196C115.677 278.47 125.577 275.844 133.302 280.331L170.914 302.175C173.31 303.567 176.314 301.838 176.314 299.067V250.771C176.314 241.151 171.188 232.26 162.863 227.439L118.421 204.544C110.69 200.067 108.051 190.171 112.528 182.439C117.004 174.707 126.9 172.069 134.631 176.545L179.073 199.441C197.388 210.046 208.665 229.607 208.665 250.771V317.567C208.665 321.612 210.817 325.351 214.315 327.382L231.231 337.207C235.014 339.404 239.756 336.674 239.756 332.299V191.241C239.756 187.106 237.507 183.297 233.885 181.301L178.028 150.506C170.204 146.193 167.358 136.354 171.671 128.53C175.984 120.706 185.823 117.86 193.646 122.173L234.426 144.655C236.822 145.976 239.756 144.243 239.756 141.507V102.638C239.756 93.7044 246.998 86.4619 255.932 86.4619Z"
                    fill={`url(#${gradientId})`}
                />
            </g>
            <defs>
                <linearGradient
                    id={gradientId}
                    x1="256.146"
                    y1="33.4077"
                    x2="244.29"
                    y2="485.927"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#E4DCFF" />
                </linearGradient>
                <clipPath id={clipId}>
                    <rect width="512" height="512" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default TreechatIcon
